/**
 * Compact toolbar column label with icon (Status / Mode / View rows).
 */

import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';

export function ToolbarRowLabel({
  icon: Icon,
  children,
}: {
  icon: LucideIcon;
  children: ReactNode;
}) {
  return (
    <span className="flex w-[5.5rem] shrink-0 items-center gap-1.5 text-[10px] font-semibold uppercase tracking-wide text-muted-foreground">
      <Icon
        className="h-3.5 w-3.5 shrink-0 opacity-90 text-muted-foreground"
        strokeWidth={2}
        aria-hidden
      />
      <span className="min-w-0 leading-none">{children}</span>
    </span>
  );
}
